/**
 * Refund and bill-revision zod schemas (docs/SPEC.md §5.4, docs/INVENTORY.md §3).
 */
import { z } from 'zod';
import { idSchema, positiveQtyMilliSchema } from './common.js';
import { PAYMENT_METHODS, REFUND_REASONS } from '../constants.js';
import { addBillLineSchema } from './selling.js';
export const refundLineSchema = z.object({
    billLineId: idSchema,
    qtyMilli: positiveQtyMilliSchema,
    restock: z.boolean().default(true),
    reason: z.enum(REFUND_REASONS).optional(),
    note: z.string().max(300).optional(),
});
export const createRefundSchema = z.object({
    billId: idSchema,
    method: z.enum(PAYMENT_METHODS).default('CASH'),
    reason: z.enum(REFUND_REASONS).default('OTHER'),
    reasonNote: z.string().max(500).optional(),
    lines: z.array(refundLineSchema).min(1),
});
export const listRefundsQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    shopId: idSchema.optional(),
    billId: idSchema.optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});
/**
 * A revision resubmits the bill's FULL line set (not a diff) — the delta
 * against what the immediately-superseded version actually took out of stock
 * is computed server-side (docs/INVENTORY.md §3), never sent by the client.
 */
export const reviseBillSchema = z.object({
    lines: z.array(addBillLineSchema).min(0),
    reason: z.string().max(300).min(1),
    /** Only required when the new total differs from what was already paid. */
    settlementMethod: z.enum(PAYMENT_METHODS).optional(),
});
//# sourceMappingURL=refunds.js.map